export const stylesGeneralComponents = {
  buttonStyles: {
    textTransform: "none",
    width: "200px",
  },

  boxButtonFiltersShareSite: { "& > button": { m: 1 } },
  shareIcon: {
    color: "#7a777d",
    marginRight: "10px",
  },
};
